import React from "react";
import { AddUserPage } from "../users/add-page";

export default props => (
  <AddUserPage
    backTo={`/partner/edit/${props.match.params.partnerId}`}
    partnerId={props.match.params.partnerId}
    username={props.match.params.id}
  />
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/admin/users-partners/Add.js